import React from 'react';
import { Icon } from '@ontruck/orc';
import VehicleImage from 'components/VehicleImage';

import { PalletsCell, WeightCell, HeightCell } from 'utils/format';
import { cellWidth } from 'modules/job-review/utils';
import { IS_TENANT } from 'tenant/config';

const StopVehicle = ({ className, vehicle }) => {
  if (vehicle?.error) {
    return (
      <div className={className}>
        <div className="cell">No vehicle assigned</div>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="cell" {...cellWidth('48px')}>
        <VehicleImage type={vehicle?.vehicle_type} color="white" />
      </div>
      <div className="cell" {...cellWidth('392px')}>
        {vehicle?.plate_number}
      </div>
      <div className="cell cell__right cell__light cell__smallpadding" {...cellWidth('70px')}>
        <WeightCell weight={vehicle?.max_weight} />
      </div>
      <div
        className="cell cell__right cell__light cell__smallpadding"
        {...cellWidth(IS_TENANT ? '34px' : '54px')}
      >
        <HeightCell height={vehicle?.container_height} convert={false} />
      </div>
      <div
        className="cell cell__right cell__light cell__smallpadding"
        {...cellWidth(IS_TENANT ? '68px' : '48px')}
      >
        <PalletsCell
          realPallets={vehicle?.max_pallets}
          typePallets={'EU_PALLET'}
          withEquivalents={false}
        />
      </div>
      <div {...cellWidth('114px')} className="cell"></div>
      <div className="cell cell__padding extras">
        <div className="extra">
          {!!vehicle?.has_liftgate && <Icon glyph="extras-liftgate" size="2rem" color="white" />}
        </div>
        <div className="extra">
          {!!vehicle?.has_lateral_loading && (
            <Icon glyph="extras-sideload" size="2rem" color="white" />
          )}
        </div>
        <div className="extra">
          {!!vehicle?.has_superior_loading && (
            <Icon glyph="extras-retractableroof" size="2rem" color="white" />
          )}
        </div>
      </div>
    </div>
  );
};

export default StopVehicle;
